export class NetworkLinkedDocumentCategory {
    //netgen start
    title: string;
    id = 0;
    //netgen end
}
